import React from 'react'

import './Gacha.css'
import { useTranslation } from "react-i18next";
import { getAssetUrl } from '../../../../utils/assetUtils';

const GachaRank9Info = ({cards}) => {
    const { t } = useTranslation();

    const makeImage = (cards) => {
        return cards.map((card) => {
            return (
                <React.Fragment key={card.id}>
                    <div className="gacha-info-card-number-title">{t('gacha_rank_info.last')}{card.number}</div>
                    <div className="gacha-info-card-image-rank1">
                        <img src={getAssetUrl(card.image_url)} alt="card" />
                        { card.is_psa_enabled == 1 && <div className="gacha-info-card-psa">PSA{card.psa}</div>}
                    </div>
                </React.Fragment>
            )
        })
    }

    return (
        <>
            {makeImage(cards)}
        </>
    )
}

export default GachaRank9Info